export const TEXTS = {
    CLIENT: "Написать психологу, с\u00A0которым у\u00A0вас сессия, вы\u00A0можете из\u00A0его профиля",
    PSY: "Начать чат вы\u00A0можете из\u00A0раздела «Клиенты»",
}
